import { createContext } from "react";
import Terminal from "../../../../utilities/data/model/Terminal";
import { CloseShiftContextType } from "./type";

export type EndOfShiftContextType = {
  shiftTerminal: Terminal;
};

export const EndOfShiftContext = createContext<
  EndOfShiftContextType | undefined
>(undefined);

export const CloseShiftProcessContext = createContext<
  CloseShiftContextType | undefined
>(undefined);
